import { Route, Routes } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Enrollment from "./pages/Enrollment";
import Error404Page from "./pages/Error404Page";
import Error403Page from "./pages/Error403Page";
import Resident from "./pages/Resident";
import Allowance from "./pages/AllowanceUpdatePage";
import DirectDepositListingPage from "./pages/DirectDepositListingPage";
import ResidentStatusListingsPage from "./pages/ResidentStatusListingsPage";
import AllowanceListingsPage from "./pages/AllowanceListingsPage";
import CareFacilityListingsPage from "./pages/CareFacilityListingsPage";
import CareFacilityUserListingsPage from "./pages/CareFacilityUserListingsPage";
import NewCareFacilityPage from "./pages/NewCareFacilityPage";
import NewClientUserPage from "./pages/NewClientUserPage";
import AdminAuditListingsPage from "./pages/AdminAuditListingsPage";
import ReportsPage from "./pages/ReportsPage";
import UserEnrollmentAuditPage from "./pages/UserEnrollmentAuditPage";
import CarefacilityAuditPage from "./pages/CarefacilityAuditPage";
import CareFacilityUserAuditPage from "./pages/CareFacilityUserAuditPage";
import ErrorPage from "./pages/ErrorPages";
import { useState, useEffect } from "react";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "./App.css";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setNavigate } from "./components/common/NavigateService";
import {
  storeAccessToken,
  storeUserDetails,
  storeIdTokenClaims,
  storeUserRole,
} from "../src/action";
import ErrorModal from "./components/common/ErrorModal";
import DownloadPage from "./pages/DownloadPage";
import AchFilesJobPage from "./pages/AchFilesJobPage";
import axiosInstance, { setAuthTokenRefresher } from "./components/common/AxiosInterceptor";
import AdminAccessControlPage from "./pages/AdminAccessControlPage";
import { getRoleOfExternalUser, getRoleOfInternalUser } from "./components/common/constants/globalconstants";
import { Box } from "@mui/material";
import AclAuditPage from "./pages/AclAuditPage";
import BillingReportPage from "./pages/BillingReportPage";
function App() {
  const {
    user,
    isAuthenticated,
    getIdTokenClaims,
    getAccessTokenSilently,
  } = useAuth0();
  const [myuser, setmyuser] = useState({});
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const [ role, setRole] = useState("");
  const [ loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const storeuser = useSelector((state) => state.storeuser);
  const storetoken = useSelector((state) => state.storetoken);
  const userAccessRole = useSelector((state)=> state.userAccessRole);
  let isAdmin = false;
   if (user !== undefined) {
    isAdmin = user["usertype"] === "internal" ? true : false;
  }

  useEffect(()=>{
    setNavigate(navigate);
  },[navigate])

  useEffect(() => {
    isAuthenticated && console.log(""); //username = nickname
    dispatch(storeUserDetails(user));
    setmyuser(user);
  }, [isAuthenticated, myuser]);

  useEffect(() => {
    let newtoken = getAccessTokenSilently();
    const claims = getIdTokenClaims();
    newtoken.then((res) => {
      dispatch(storeAccessToken(res));
    });

    claims.then((claim) => {
      dispatch(storeIdTokenClaims(claim));
    });
  }, [isAuthenticated]);

  //const storeuser = useSelector((state) => state.storeuser);
 
  function preventBack() {
    window.history.forward();
  }

  useEffect(() => {
    setTimeout(preventBack(), 0);
    window.onunload = function () {
      return null;
    };
  }, []);

 
  const [isauthorized, setAuthorized] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setAuthorized(true);
    }, 1000);
  }, []);

  useEffect(()=> {
    setAuthTokenRefresher(getAccessTokenSilently);
  },[getAccessTokenSilently]);

   useEffect(() =>{
     if(role === "" && storetoken !== "storeToken" 
      && storeuser && storeuser.email !== "email" && userAccessRole === ""){
        setLoading(true);
        getUserRole();
     }
   },[storeuser, storetoken, userAccessRole]);
 

  const getUserRole = async() =>{
        try {          
          setLoading(true);
          let response;
          const request = {
            userName: storeuser.email
          }
          if(isAdmin){
            response = await axiosInstance.post(`${getRoleOfInternalUser}`,JSON.stringify(request));
          }
          else if(!isAdmin){
            response = await axiosInstance.post(`${getRoleOfExternalUser}`,JSON.stringify(request));
          }
  
          if(response.data.isSuccess){
             const role = response.data.result && response.data.result.roleName;
             setRole(role);
             dispatch(storeUserRole(role));
             seterrormodalOpen(false);
          }
          else if(!response.data.isSuccess){
            seterrormodalOpen(true);
            setLoading(false);
          }
          setLoading(false);
      } catch (error) {
        console.log(error.message);
        setLoading(false);
        seterrormodalOpen(true);
      }
      }

  if(loading){
    return <div>
        <Box sx={{ display: 'flex', alignContent:"center", justifyContent:"center"}}>
          Loading...
        </Box>
    </div>
  }  
  
  return (
    <div>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Routes>
        <Route path="/" element={<Login />} />
        
        {!isAuthenticated && isauthorized && (
          <Route path="*" element={<Login />} />
        )}

        {isAuthenticated && (
          <>
            <Route path="*" element={<Error404Page />} />

            <Route path="/home" element={<Home />} />

            <Route
              path="/resident"
              element={user?.usertype === "external" && (userAccessRole === "Write" || role === "Write")? <Resident /> : <Error403Page />}
            />

            <Route
              path="/allowance"
              element={user?.usertype === "external" && (userAccessRole === "Write" || role === "Write")? <Allowance /> : <Error403Page />}
            />

            <Route
              path="/allowance/:action"
              element={user?.usertype === "external" && (userAccessRole === "Write" || role === "Write")? <Allowance /> : <Error403Page />}
            />

            <Route
              path="/enrollment"
              element={
                user && user.usertype === "external" && (userAccessRole === "Write" || role === "Write")? <Enrollment /> :
                <Error403Page/>
              }
            />

            <Route
              path="/enrollment/:action"
              element={
                user?.usertype === "external" && (userAccessRole === "Write" || role === "Write")? <Enrollment /> : <Error403Page />
              }
            />

            <Route
              path="/directDepositListing"
              element={
                user?.usertype === "external" ? (
                  <DirectDepositListingPage />
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/residentListings"
              element={
                user?.usertype === "external" ? (
                  <ResidentStatusListingsPage />
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/reports"
              element={
                user?.usertype === "external" ? <ReportsPage /> : <Error403Page />
              }
            />

            <Route
              path="/userEnrollmentReports"
              element={
                user?.usertype === "external" ? <UserEnrollmentAuditPage /> : <Error403Page />
              }
            />

            <Route
              path="/allowanceListings"
              element={
                user?.usertype === "external" ? (
                  <AllowanceListingsPage />
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/admin/careFacilityListings"
              element={
                user?.usertype === "internal" ? (
                  <CareFacilityListingsPage />
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/admin/careUserListings"
              element={
                user?.usertype === "internal" ? (
                  <CareFacilityUserListingsPage />
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/admin/careUserListings/:action"
              element={
                user?.usertype === "internal" ? (
                  <CareFacilityUserListingsPage />
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/admin/newCareFacility"
              element={
                user?.usertype === "internal" && 
                (userAccessRole === "Write" || role === "Write" || userAccessRole === "Admin" || role === "Admin")? (
                  <NewCareFacilityPage />
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/admin/newCareFacility/:action"
              element={
                user?.usertype === "internal" &&
                (userAccessRole === "Write" || role === "Write" || userAccessRole === "Admin" || role === "Admin")? (
                  <NewCareFacilityPage />
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="admin/newClientUser"
              element={
                user?.usertype === "internal" &&
                (userAccessRole === "Write" || role === "Write" || userAccessRole === "Admin" || role === "Admin")? (
                  <NewClientUserPage />
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/admin/newClientUser/:action"
              element={
                user?.usertype === "internal" &&
                (userAccessRole === "Write" || role === "Write" || userAccessRole === "Admin" || role === "Admin")? (
                  <NewClientUserPage />
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/admin/loginReport"
              element={
                user?.usertype === "internal" ? (
                  <AdminAuditListingsPage/>
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/admin/careFacilityAuditReport"
              element={
                user?.usertype === "internal" ? (
                  <CarefacilityAuditPage/>
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/admin/careFacilityUserAuditReport"
              element={
                user?.usertype === "internal" ? (
                  <CareFacilityUserAuditPage/>
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/admin/aclAuditReport"
              element={
                user?.usertype === "internal" ? (
                  <AclAuditPage/>
                ) : (
                  <Error403Page />
                )
              }
            />

             <Route
              path="/admin/billingReport"
              element={
                user?.usertype === "internal" ? (
                  <BillingReportPage/>
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route
              path="/admin/downloadListings"
              element={
                user?.usertype === "internal" ? (
                  <DownloadPage/>
                ) : (
                  <Error403Page />
                )
              }
            />
            
            <Route
              path="/admin/achFilesJob"
              element={
                user?.usertype === "internal" ? (
                  <AchFilesJobPage/>
                ) : (
                  <Error403Page />
                )
              }
            />
            
            <Route
              path="/admin/acl"
              element={
                user?.usertype === "internal" && (userAccessRole === "Write" || role === "Write") ? (
                  <AdminAccessControlPage/>
                ) : (
                  <Error403Page />
                )
              }
            />

            <Route path="/Error403Page" element={<Error403Page />} />
            <Route path="/errorpage" element={<ErrorPage />} />
          </>
        )}

        
      </Routes>
    </LocalizationProvider>
    {errormodalopen && (
        <ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
      )}
  </div>
    
  );
}

export default App;
